import { render, staticRenderFns } from "./EndpointsCard.vue?vue&type=template&id=b27b4798"
import script from "./EndpointsCard.vue?vue&type=script&lang=js"
export * from "./EndpointsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports